import { HttpParams } from '@angular/common/http';
import { ElementRef } from '@angular/core';

export const stickyActiveShadow = (element: ElementRef) => {
  if (window && !window.IntersectionObserver) return;
  const observer = new IntersectionObserver(
    ([entries]) =>
      entries.target.classList.toggle(
        'is-sticky',
        entries.boundingClientRect.top < 0
      ),
    { threshold: 1.0 }
  );

  observer.observe(element.nativeElement);

  return observer;
};

export const getHttpParams = (qParams: {
  [key: string]: string | number | boolean;
}): HttpParams => {
  let params = new HttpParams();

  Object.entries(qParams).forEach(param => {
    params = params.set(param[0], param[1]);
  });

  return params;
};
